export default () => ({
    sliders: []
})